// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { ConfluenceUpsellMessage as ConfluenceUpsellMessageType } from './main.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyConfluenceUpsellMessage = lazy<typeof ConfluenceUpsellMessageType>(
	() =>
		import(/* webpackChunkName: "async-jsm-kb-confluence-upsell-message" */ './main').then(
			(module) => module.ConfluenceUpsellMessage,
		),
	{ ssr: false },
);

export const ConfluenceUpsellMessage = (
	props: JSX.LibraryManagedAttributes<
		typeof ConfluenceUpsellMessageType,
		ComponentProps<typeof ConfluenceUpsellMessageType>
	>,
) => (
	<Placeholder name="async-jsm-kb-confluence-upsell-message" fallback={null}>
		{/* @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'IntrinsicAttributes & { children?: ReactNode; }'. */}
		<LazyConfluenceUpsellMessage {...props} />
	</Placeholder>
);
